import L from "leaflet";
import { Marker, useMapEvents } from "react-leaflet";
import markerPin from "_assets/imgs/mapa/markers/map-icon-black.png";
import { useCriarManifestacao } from "../contexts/CriarManifestacaoProvider";

const markerIcon = new L.Icon({
  iconUrl: markerPin,
  iconSize: [30.48, 50],
  iconAnchor: [15.24, 50],
  shadowSize: [61, 61]
});

export function MarkerChooseHandler() {
  const { isCreating, latLngSelected, setLatLngSelected } =
    useCriarManifestacao();

  useMapEvents({
    click(e) {
      if (!isCreating) {
        return;
      }
      setLatLngSelected(e.latlng);
    }
  });

  if (!latLngSelected || !isCreating) {
    return null;
  }

  return <Marker position={latLngSelected ?? undefined} icon={markerIcon} />;
}
